import { CardMedia, Grid } from "@mui/material";
import { NumberFormatter } from "utils/helpers";
import { useStyles } from "./basket-content-style";
import { useTranslation } from "react-i18next";
import { ELEMENT_ID } from "utils/constants";
import contentBg from "assets/images/course.png";
import { ProductBasket } from "store/bookingJourney";

type BasketContentProps = {
  products: ProductBasket[];
};

export const BasketContent: React.FC<BasketContentProps> = ({ products }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const basketContentSize =
    process.env.REACT_APP_SHOW_IMAGE_IN_BASKETCONTENT.toString() === "true" ? 9 : 12;

  return (
    <Grid container className={classes.content}>
      <Grid size={{ xs: 12, sm: 12, md: 12 }} className={classes.gridContainer}>
        {products?.map((x, index: number) => (
          <Grid id={`${ELEMENT_ID.BASKETCONTENT}-${index}`} key={index} container>
            {process.env.REACT_APP_SHOW_IMAGE_IN_BASKETCONTENT.toString() === "true" && (
              <Grid size={{ xs: 3, sm: 3, md: 3 }}>
                <CardMedia
                  className={classes.media}
                  image={
                    process.env.REACT_APP_SHOW_DEFAULT_IMAGE_IBF.toString() === "true"
                      ? contentBg
                      : `${x.image}`
                  }
                  id={`${ELEMENT_ID.BASKETCONTENT}-${ELEMENT_ID.IMAGE}-${index}`}
                />
              </Grid>
            )}
            <Grid
              size={{ xs: basketContentSize, sm: basketContentSize, md: basketContentSize }}
              className={classes.courseContainer}
            >
              <Grid>
                <Grid
                  className={classes.id}
                  id={`${ELEMENT_ID.BASKETCONTENT}-${ELEMENT_ID.COURSEID}-${index}`}
                >
                  {t("id")}: {x.courseId}
                </Grid>
              </Grid>
              <Grid>
                <Grid
                  size={{ xs: 11, sm: 11, md: 11 }}
                  id={`${ELEMENT_ID.BASKETCONTENT}-${ELEMENT_ID.COURSE}-${ELEMENT_ID.NAME}-${index}`}
                  className={classes.courseName}
                >
                  {x.title}
                </Grid>
              </Grid>
              <Grid container className={classes.quantityPriceContainer}>
                <Grid
                  size={{ xs: 2, sm: 2, md: 2 }}
                  id={`${ELEMENT_ID.BASKETCONTENT}-${ELEMENT_ID.QUANTITY}-${index}`}
                  className={classes.quantity}
                >
                  {x.quantity}
                </Grid>
                <Grid size={{ xs: 6, sm: 6, md: 6 }}></Grid>
                <Grid
                  size={{ xs: 2, sm: 2, md: 3 }}
                  id={`${ELEMENT_ID.BASKETCONTENT}-${ELEMENT_ID.PRICE}-${index}`}
                  className={classes.price}
                >
                  {NumberFormatter(x.currency).format(x.subTotal)}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};
